import { css } from "@emotion/core"

export const autolink = css`
  svg {
    visibility: hidden;
  }
  &:hover {
    a {
      svg {
        visibility: visible;
      }
    }
  }
`
